import { _ as e } from "./index.es460.js";
var t = e;
function o(r) {
  var n = new r.constructor(r.byteLength);
  return new t(n).set(new t(r)), n;
}
var c = o;
export {
  c as _
};
//# sourceMappingURL=index.es392.js.map
